import type { FC } from "react"

import type { Point2d } from "@logic/lib/2d"

const TEXT_STYLE = { fontSize: `14px`, fill: `#575757`, fontWeight: `bold` }

const getFixedNumber = (num: number | null) =>
  num === null ? 0 : num.toFixed(2)

export const CoordinateTooltip: FC<{
  says: string
  where: Point2d
  size?: { w: number; h: number }
}> = ({ says, where: { x, y }, size = { w: 120, h: 30 } }) => (
  <g style={{ pointerEvents: `none`, userSelect: `none` }}>
    <rect
      x={x}
      y={y}
      width={size.w}
      height={size.h}
      fill="#fff"
      rx="1"
      opacity={0.5}
      overflow="hidden"
    />
    <text key={says + x + y} x={x + 10} y={y + 20} style={TEXT_STYLE}>
      {says}
    </text>
  </g>
)
